import React, { FC } from 'react';

interface Props {
  className?: string;
  size?: number;
  color?: string;
}

export const ArrowUpIcon: FC<Props> = ({ className, size = 24, color = 'currentColor' }) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M5 9L6.41 10.41L11 5.83V22H13V5.83L17.59 10.42L19 9L12 2L5 9Z" />
    </svg>
  );
};
